    document.addEventListener('DOMContentLoaded', function() {
      var searchBtn = document.getElementById('header-search-icon');
      var searchContainer = document.getElementById('search-bar-container');
      var closeBtn = document.getElementById('close-search-btn');

      searchBtn.addEventListener('click', function() {
        searchContainer.style.display = 'block';
        searchBtn.style.display = 'none';
      });

      closeBtn.addEventListener('click', function() {
        searchContainer.style.display = 'none';
        searchBtn.style.display = 'inline-block';
      });
    });
    const predictiveSearch = document.getElementById('predictive-search');